import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { breadcrumbSchema } from './SEO';
import { SERVICE_AREAS_BY_SLUG } from '../data/serviceAreas';
import { SEO_SERVICES_BY_SLUG } from '../data/seoServices';

// SEO: visible breadcrumbs + BreadcrumbList JSON-LD for core secondary pages (geo/service pages render their own)
const CORE = {
  about: 'About SurveysMaps', services: 'Survey CAD Drafting Services', pricing: 'Drafting Pricing', portfolio: 'Project Portfolio',
  contact: 'Contact Us', faq: 'FAQ', blog: 'Blog', careers: 'Careers', quote: 'Quote Calculator', 'get-started': 'Get Started',
  'service-areas': 'Service Areas', support: 'Customer Support', samples: 'Request Samples', terms: 'Terms & Conditions', privacy: 'Privacy Policy', security: 'Data Security',
};

export const AutoBreadcrumbs = () => {
  const { pathname } = useLocation();
  const seg = pathname.split('/').filter(Boolean);
  let items = null;
  if (seg.length === 1 && CORE[seg[0]]) items = [{ name: 'Home', path: '/' }, { name: CORE[seg[0]], path: `/${seg[0]}` }];
  const state = seg[0] === 'service-areas' && seg.length === 2 && SERVICE_AREAS_BY_SLUG[seg[1]];
  if (state) items = [{ name: 'Home', path: '/' }, { name: 'Service Areas', path: '/service-areas' }, { name: state.name, path: pathname }];
  if (seg[0] === 'services' && seg.length === 2 && !SEO_SERVICES_BY_SLUG[seg[1]]) items = [{ name: 'Home', path: '/' }, { name: 'Services', path: '/services' }, { name: seg[1].replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()), path: pathname }];
  if (!items) return null;
  const jsonLd = seg.length === 1 && seg[0] !== 'service-areas';
  return (
    <>
      {jsonLd && <Helmet><script type="application/ld+json">{JSON.stringify(breadcrumbSchema(items))}</script></Helmet>}
      <nav aria-label="Breadcrumb" className="bg-zinc-50 border-b border-zinc-200" data-testid="auto-breadcrumbs">
        <ol className="container-custom flex items-center gap-1.5 py-2 text-xs text-zinc-500">
          {items.slice(0, -1).map(it => (
            <li key={it.path} className="flex items-center gap-1.5"><Link to={it.path} className="hover:text-[#3B82F6]">{it.name}</Link><span aria-hidden="true">›</span></li>
          ))}
          <li aria-current="page" className="text-zinc-800 font-medium">{items[items.length - 1].name}</li>
        </ol>
      </nav>
    </>
  );
};
